"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const art_layout_names_1 = __importDefault(require("./art-layout-names"));
const art_sets_backgrounds_1 = __importDefault(require("./art-sets-backgrounds"));
const tiles_1 = require("../tiles");
const twoLayouts = [
    {
        id: art_layout_names_1.default.TWINS_PORTRAIT,
        displayName: 'Twins',
        displayLayoutIndex: 2,
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DESK_TWINS,
                tiles: [
                    {
                        id: 'couch_2_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3336252189141856,
                            y: 0.30297723292469353,
                            width: 0.14886164623467601,
                            height: 0.19702276707530647
                        }
                    },
                    {
                        id: 'couch_2_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5175131348511384,
                            y: 0.30297723292469353,
                            width: 0.14886164623467601,
                            height: 0.19702276707530647
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DESK_TWINS,
                tiles: [
                    {
                        id: 'couch_2_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.2618213660245184,
                            y: 0.2486865148861646,
                            width: 0.22066549912434325,
                            height: 0.29246935201401053
                        }
                    },
                    {
                        id: 'couch_2_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5175131348511384,
                            y: 0.2486865148861646,
                            width: 0.22066549912434325,
                            height: 0.29246935201401053
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DESK_TWINS,
                tiles: [
                    {
                        id: 'couch_2_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.13485113835376533,
                            y: 0.08669001751313485,
                            width: 0.3476357267950963,
                            height: 0.4807355516637478
                        }
                    },
                    {
                        id: 'couch_2_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5175131348511384,
                            y: 0.08669001751313485,
                            width: 0.3476357267950963,
                            height: 0.4807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DESK_ZOOMEDOUT,
                tiles: [
                    {
                        id: 'desk_2_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X36,
                        normalizedFrame: {
                            x: 0.08026106417107155,
                            y: 0.06042031523642732,
                            width: 0.40397711446290385,
                            height: 0.5376532399299475
                        }
                    },
                    {
                        id: 'desk_2_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X36,
                        normalizedFrame: {
                            x: 0.5163381219644165,
                            y: 0.06042031523642732,
                            width: 0.40397711446290385,
                            height: 0.5376532399299475
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.TWINS_LANDSCAPE,
        displayName: 'Twins',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.ARMCHAIR,
                tiles: [
                    {
                        id: 'scene_couch_wall_2_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_11X8,
                        normalizedFrame: {
                            x: 0.34851138353765326,
                            y: 0.2276707530647986,
                            width: 0.15148861646234676,
                            height: 0.11471103327495621
                        }
                    },
                    {
                        id: 'scene_couch_wall_2_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_11X8,
                        normalizedFrame: {
                            x: 0.34851138353765326,
                            y: 0.35901926444833626,
                            width: 0.15148861646234676,
                            height: 0.11471103327495621
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.ARMCHAIR,
                tiles: [
                    {
                        id: 'scene_couch_wall_2_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_16X12,
                        normalizedFrame: {
                            x: 0.3345008756567426,
                            y: 0.1584938704028021,
                            width: 0.23555166374781086,
                            height: 0.1777583187390543
                        }
                    },
                    {
                        id: 'scene_couch_wall_2_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_16X12,
                        normalizedFrame: {
                            x: 0.3345008756567426,
                            y: 0.35901926444833626,
                            width: 0.23555166374781086,
                            height: 0.1777583187390543
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.ARMCHAIR,
                tiles: [
                    {
                        id: 'scene_couch_wall_2_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X20,
                        normalizedFrame: {
                            x: 0.20928196147110456,
                            y: 0.03502626970227671,
                            width: 0.3975481611208406,
                            height: 0.29422066549912435
                        }
                    },
                    {
                        id: 'scene_couch_wall_2_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X20,
                        normalizedFrame: {
                            x: 0.20928196147110334,
                            y: 0.35288966725043786,
                            width: 0.3975481611208406,
                            height: 0.29422066549912435
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.TWINS_SQUARE,
        displayName: 'Twins',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DESK_TWINS,
                tiles: [
                    {
                        id: 'square_8x8_2_1',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5175131348511384,
                            y: 0.21628721541155868,
                            width: 0.14886164623467601,
                            height: 0.14886164623467601
                        }
                    },
                    {
                        id: 'square_8x8_2_2',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.3336252189141856,
                            y: 0.21628721541155868,
                            width: 0.14886164623467601,
                            height: 0.14886164623467601
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DESK_TWINS,
                tiles: [
                    {
                        id: 'square_12x12_2_1',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.5175131348511384,
                            y: 0.18038528896672504,
                            width: 0.22066549912434325,
                            height: 0.22066549912434325
                        }
                    },
                    {
                        id: 'square_12x12_2_2',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.2618213660245184,
                            y: 0.18038528896672504,
                            width: 0.22066549912434325,
                            height: 0.22066549912434325
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DESK_TWINS,
                tiles: [
                    {
                        id: 'desk_2_1',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.5175131348511384,
                            y: 0.11646234676007006,
                            width: 0.3476357267950963,
                            height: 0.3476357267950963
                        }
                    },
                    {
                        id: 'desk_2_2',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.13485113835376533,
                            y: 0.11646234676007006,
                            width: 0.3476357267950963,
                            height: 0.3476357267950963
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.TWO_TOWER,
        displayName: 'Tower',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_2_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.659369527145359,
                            y: 0.20665499124343256,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_2_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.659369527145359,
                            y: 0.351138353765324,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_2_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6427320490367776,
                            y: 0.14010507880910683,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_2_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6427320490367776,
                            y: 0.34413309982486867,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_2_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5954465849387041,
                            y: 0.06042031523642732,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'door_2_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5954465849387041,
                            y: 0.38266199649737304,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.TWO_STAIRWAY,
        displayName: 'Stairway',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_2_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.4124343257443082,
                            y: 0.1725043782837128,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_2_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.11996497373029773,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_2_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.37478108581436076,
                            y: 0.20052539404553416,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_2_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.12259194395796848,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_2_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.30823117338003503,
                            y: 0.2040280210157618,
                            width: 0.18213660245183888,
                            height: 0.2521891418563923
                        }
                    },
                    {
                        id: 'stairway_2_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.07793345008756568,
                            width: 0.18213660245183888,
                            height: 0.2521891418563923
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.TWO_MOLECULAR,
        displayName: 'Molecular',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DESK_LAYOUTS,
                tiles: [
                    {
                        id: 'desk_2_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.29772329246935203,
                            y: 0.2548161120840631,
                            width: 0.14886164623467601,
                            height: 0.19702276707530647
                        }
                    },
                    {
                        id: 'desk_2_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4816112084063047,
                            y: 0.2075306479859895,
                            width: 0.22066549912434325,
                            height: 0.29246935201401053
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DESK_LAYOUTS,
                tiles: [
                    {
                        id: 'desk_2_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.1987740805604203,
                            y: 0.22679509632224168,
                            width: 0.22066549912434325,
                            height: 0.29246935201401053
                        }
                    },
                    {
                        id: 'desk_2_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.45446584938704027,
                            y: 0.13222416812609458,
                            width: 0.3476357267950963,
                            height: 0.4807355516637478
                        }
                    }
                ]
            }
        ]
    }
];
exports.default = twoLayouts;
//# sourceMappingURL=two.js.map